import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { StateDropdownDTO } from "../../models/cust-address/cust-address-model";
import { ErrorMessage } from "formik";
 

const getUserAddress = async (UserAdrressId? : number) => {
  try {
    const userAddress: any = await api
      .get(ApiConstant.apiUserAddress + UserAdrressId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch (e) {
    console.log("error in getUserAddress");
    return [];
  }
};

const getUserAddressById = async (userId: number) => {
  try {
    const userAddress: any = await api
      .get(ApiConstant.getUserAddressById + userId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch (e) {
    console.log("error in getUserAddress");
    return [];
  }
};

const getAddressByAreaId = async (areaId: number) => {
  try {
    const areaAddress: any = await api
      .get(ApiConstant.getAreaAddressById + "?$filter=areaId  eq " + areaId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get address data.", error);
      });
    const response = areaAddress != null ? areaAddress : null;
    return response;
  } catch (e) {
    console.log("error in areaAddress");
    return [];
  }
};

const addUserAddress = async (address: any) => {
  try {
    const userAddress: any = await api
      .post(ApiConstant.apiUserAddress, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error creating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in add user address");
    return false;
  }
};

const addAdminAddress = async (address: any) => {
  try {
    const userAddress: any = await api
      .post(ApiConstant.apiAdminAddress, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error creating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in add user address");
    return false;
  }
};



const addAdminAddress1 = async (address: any) => {
  try {
    const userAddress: any = await api
      .put(ApiConstant.apiAdminAddress1, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error creating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in add user address");
    return false;
  }
};
const apiuserAddress1 = async (address: any) => {
  try {
    const userAddress: any = await api
      .post(ApiConstant.apiuserAddress, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error creating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in add user address");
    return false;
  }
};

const addAdminAddress2 = async (address: any) => {
  try {
    const userAddress: any = await api
      .post(ApiConstant.apiAdminAddress2, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error creating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in add user address");
    return false;
  }
};

const editUserAddress = async (address: any) => {
  try {
    console.log("Updating Address Payload:", address);
    const userAddress: any = await api
      .put(ApiConstant.apiUserAddress, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("Error updating address data:", error);
      });
    return userAddress != null ? userAddress : null;
  } catch {
    console.log("Error in edit user address");
    return false;
  }
};

const updateGPSLocation = async (addressId: number, gpsLocation: string) => {
  try {
    const userAddress: any = await api
      .put(ApiConstant.updateGPSLocation, {
        userAddressID: addressId,
        gpsLocation: gpsLocation,
      })
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error updating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in update gps location");
    return false;
  }
};

const updateGPSLocation1 = async (addressId: number, gpsLocation: string,orderId: number) => {
  try {
    const userAddress: any = await api
      .put(ApiConstant.updateGPSLocation1, {
        userAddressID: addressId,
        gpsLocation: gpsLocation,
         orderID: orderId,
      })
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error updating address data.", error);
      });
    const response = userAddress != null ? userAddress : null;
    return response;
  } catch {
    console.log("error in update gps location");
    return false;
  }
};

// const deleteUserAddress = async (addressId: number) => {
//   try {
//     console.warn(ApiConstant.deleteUserAddress + addressId);
//     await api
//       .delete(ApiConstant.deleteUserAddress + addressId)
//       .then((res: any) => {
//         if (res) return res.data;
//         else return null;
//       })
//       .catch(function (error: any) {
//         console.error("error deleting address data.", error);
//       });
//   } catch {
//     console.log("error in delete user address");
//     return;
//   }
// };
const deleteUserAddress = async (addressId: number) => {
  try {
    const { data } = await api.delete(ApiConstant.deleteUserAddress + addressId);
 
    if (!data?.isSuccess) {
      return { isSuccess: false, message: data?.message || "Failed to delete address" };
    }
    return { isSuccess: true, message: "Address deleted successfully" };
  } catch (error: any) {
    const errorMessage = error.response?.data?.message ||
      (error.request ? "Network error. Please check your internet connection." : "An unexpected error occurred.");
 
    return { isSuccess: false, message: errorMessage };
  }
};

const getCountries = async () => {
  try {
    const countries: any = await api
      .get(ApiConstant.getCountries)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get countries data.", error);
      });
    const response = countries != null ? countries : null;
    return response;
  } catch (e) {
    console.log("error in getCountries");
    return [];
  }
};


const getStates = async (countryId: any) => {
  try {
    const countries: any = await api
      .get(ApiConstant.getStatesByCounty + countryId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get states data.", error);
      });
    const response = countries != null ? countries : null;
    return response;
  } catch (e) {
    console.log("error in getStates");
    return [];
  }
};

const getCities = async (stateId: any) => {
  try {
    const countries: any = await api
      .get(ApiConstant.getCitiesByState + stateId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get states data.", error);
      });
    const response = countries != null ? countries : null;
    return response;
  } catch (e) {
    console.log("error in getStates");
    return [];
  }
};

const getInvoiceUsers = async () => {
  try {
    const invoiceUsers: any = await api
      .get(ApiConstant.getInvoiceUsers)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get invoice users data.", error);
      });
      
    if (!invoiceUsers) return [];

    const response = invoiceUsers.map((u: any) => ({
      ...u,
      displayName: `${u.name} - ${u.primaryContactNbr}`,
    }));

    return response;
  } catch (e) {
    console.log("error in get invoice users");
    return [];
  }
};

const getAddress = async (pincode: number) => {
  try {
    const address: any = await api
      .get(ApiConstant.pincodeSearch + pincode)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get invoice users data.", error);
      });
    const response = address != null ? address : null;
    return response;
  } catch (e) {
    console.log("error in get invoice users");
    return [];
  }
};

const updateUserAddressOnEdit = async (address: any) => {
  try {
    const editAddress: any = await api
      .put(ApiConstant.updateUserAdressEdit, address)
      .then((result: any) => {
        if (result) return result.data;
        else return null;                                         
      })
      .catch(function (error: any) {
        console.error("error updating address data.", error);
      });
    const response = editAddress != null ? editAddress : null;
    return response;
  } catch {
    console.log("error in update user address");
    return false;
  }
};
const canEditAddress = async (userAddressId: number) => {
  try {
    const response = await api.get(`${ApiConstant.canEditAddress}${userAddressId}`);
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 403) {
      return {
        isSuccess: false,
        message: "Address cannot be edited because it has active orders"
      };
    }
    return {
      isSuccess: true,
      message: error.message
    };
  }
};
const addArea = async (filter: any) => {
  try {
    const response = await api.post(ApiConstant.addArea, filter);
 
    if (response && response.data) {
      return response.data;  
    } else {
      console.error("No data received from API");
      return { isSuccess: false };  
    }
  } catch (error) {
    console.error("Error creating address data:", error);
    return { isSuccess: false };  
  }
};
 
const getAllPincodeArea = async (pageNumber: number, pageSize: number) => {
  try {
    const result = await api.post(ApiConstant.getAllPincodeArea, {
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
 
    if (result && result.data) {
      return result.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("Error in getting all PincodeArea data:", e);
    return [];
  }
};
 
const searchFilterPincode = async(filterBy:any, searchTerm:any, pageNumber:number, pageSize:number )=>{
  try{
    const result = await api.post(ApiConstant.searchFilterPincode, {
      filterBy: filterBy,
      searchTerm: searchTerm,
      pageNumber:pageNumber,
      pageSize: pageSize,
    });
    if(result && result.data){
      return result.data;
    } else {
      return null;
    }
  }
  catch(e){
    console.log("Error in getting searchFilterPincode:", e);
    return[];
  }
};
 
const getAllCountryNames = async () => {
  try {
    const countries = await api
      .post(ApiConstant.getAllCountryNames)  
      .then((result) => {
        if (result) {
          return result.data;
        } else {
          return null;
        }
      });
    return countries ? countries : [];
  } catch (e) {
    console.log("Error in getAllCountryNames:", e);
    return [];
  }
};
 
const getStatesByCountryID = async (countryId: any) => {
  try {
    const states: any = await api
      .get(ApiConstant.getStatesByCountryID + countryId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get states data.", error);
      });
    const response = states != null ? states : null;
    return response;
  } catch (e) {
    console.log("error in getStates");
    return [];
  }
};
 
const getDistrictsByStateId = async (stateId: any) => {
  try {
    const districts: any = await api
      .get(ApiConstant.getDistrictsByStateId + stateId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get district data.", error);
      });
    const response = districts != null ? districts : null;
    return response;
  } catch (e) {
    console.log("error in getDistrictsByStateId");
    return [];
  }
};
 
const getSubDistrictsByStateId = async (districtId: any) => {
  try {
    const subDistricts: any = await api
      .get(ApiConstant.getSubDistrictsByDistrictId + districtId)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get subDistricts data.", error);
      });
    const response = subDistricts != null ? subDistricts : null;
    return response;
  } catch (e) {
    console.log("error in getSubDistrictsByStateId");
    return [];
  }
};
const addNewCountry = async (countryData: any) => {
  try {
    const response = await api.post(ApiConstant.addNewCountry, countryData);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error adding new country:", error);
    return { isSuccess: false };
  }
};
 
const addNewState = async (stateData: any) => {
  try {
    const response = await api.post(ApiConstant.addNewState, stateData);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error adding new state:", error);
    return { isSuccess: false };
  }
};
 
const addNewDistrict = async (districtData: any) => {
  try {
    const response = await api.post(ApiConstant.addNewDistrict, districtData);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error adding new district:", error);
    return { isSuccess: false };
  }
};
const addNewSubDistrict = async (districtData: any) => {
  try {
    const response = await api.post(ApiConstant.addNewDistrict, districtData);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error adding new sub district:", error);
    return { isSuccess: false };
  }
 
};
  
const GetAllCountries = async (pageNumber: number, pageSize: number) => {
  try {
    const result = await api.post(ApiConstant.GetAllCountries, {
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
 
    if (result && result.data) {
      return result.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("Error in getting all Countries data:", e);
    return [];
  }
};
 
 
const searchFilterCountries = async(searchTerm:any, pageNumber:number, pageSize:number )=>{
  try{
    const result = await api.post(ApiConstant.GetAllCountriesByFilter, {
      searchTerm: searchTerm,
      pageNumber:pageNumber,
      pageSize: pageSize,
    });
    if(result && result.data){
      return result.data;
    } else {
      return null;
    }
  }
  catch(e){
    console.log("Error in getting searchFilterCountries:", e);
    return[];
  }
};
const UpdateCountries = async (UpdateCountries: any) => {  
  try {
    const Countries: any = await api
      .post(ApiConstant.UpdateCountries, UpdateCountries)
      .then((result: any) => {
        if (result)            
          return result.data;
        else
          return null;        
      })
      .catch(function (error: any) {
        console.error('error updating countries data.', error);
      });
 
    const response = Countries != null ? Countries : null;        
    return response;
  }
  catch (e) {
    console.log('error in UpdateCountries function.', e);
    return [];
  }
}
 
const deleteCountries = async (countryId: number) => {
  try {
      const deleteCountries: any = await api
      .delete(ApiConstant.DeleteCountries + countryId)
      .then((res: any)=> {
          if(res)            
              return res.data;
          else
              return null;        
      })
      .catch(function (error: any) {
          console.error('error deleting countries.', error);
      });
      const response = deleteCountries != null ? deleteCountries : null;        
      return response;
  }
  catch
  {
      console.log('error in delete customer address');
      return false;
  }
}
  
const getAllStates = async (pageNumber: any, pageSize: any) => {
  try {
    const result = await api.post(ApiConstant.getStates, {
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
 
    if (result && result.data) {
      return result.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("Error in getting all State data:", e);
    return [];
  }
};
 
const getAllStatesByfilter = async(searchTerm:any, pageNumber:number, pageSize:number )=>{
  try{
    const result = await api.post(ApiConstant.getAllStatesByfilter, {
      searchTerm: searchTerm,
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
    if(result && result.data){
      return result.data;
    } else {
      return null;
    }
  }
  catch(e){
    console.log("Error in getting filterSearchAll:", e);
    return[];
  }
};
 
const updateState = async (stateId: number, stateName: string) => {
  try {
    const editState: any = await api
      .put(ApiConstant.updateState, {
        stateId: stateId,
        stateName: stateName,
      })
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error updating state data.", error);
      });
    const response = editState != null ? editState : null;
    return response;
  } catch {
    console.log("error in update state");
    return false;
  }
};
 
const deletestate = async (stateId: number): Promise<{ isSuccess: boolean; message: string } | null> => {
  try {
      console.warn(ApiConstant.deletestate + stateId);
      const res = await api.delete(ApiConstant.deletestate + stateId);
 
      if (res) {
          return res.data;
      } else {
          return null;
      }
  } catch (error) {
      console.error("Error deleting deletestate data.", error);
      return null;
  }
};
 
const getDistricts = async (pageNumber: number, pageSize: number) => {
  try {
    const response = await api.post(ApiConstant.getDistricts, {
      pageNumber,
      pageSize,
      _: Date.now()
    });
   
    return {
      districts: response.data?.districts || [],
      totalRecords: response.data?.totalRecords || 0
    };
  } catch (error) {
    console.error("Error fetching districts:", error);
    return { districts: [], totalRecords: 0 };
  }
};
 
const searchStates = async (request: { keyword: string }): Promise<StateDropdownDTO[]> => {
  try {
    const states: any = await api
      .post(ApiConstant.searchStates, request)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error searching states data.", error);
      });
    const response = states != null ? states : [];
    return response;
  } catch (e) {
    console.log("error in searchStates");
    return [];
  }
};
 
const keywordSearchFilter = async(searchTerm:any,pageNumber:number, pageSize:number )=>{
  try{
    const result = await api.post(ApiConstant.keywordSearchFilter, {
      searchTerm: searchTerm,
      pageNumber:pageNumber,
      pageSize: pageSize,
    });
    if(result && result.data){
      return result.data;
    } else {
      return null;
    }
  }
  catch(e){
    console.log("Error in getting keywordSearch:", e);
    return[];
  }
};
 
 
const updatedistrict = async (districtId: number, districtName: string) => {
  try {
    const editDistrict: any = await api
      .put(ApiConstant.updatedistrict, {
        districtId: districtId,
        districtName: districtName,
      })
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error updating district data.", error);
      });
    const response = editDistrict != null ? editDistrict : null;
    return response;
  } catch {
    console.log("error in district");
    return false;
  }
};
 
const deleteDistrict = async (districtId: number) => {
  try {
    const response = await api.delete(`${ApiConstant.deleteDistrict}${districtId}`);
    if (response.data) {
      return {
        isSuccess: response.data.isSuccess || false,
        message: response.data.message || 'District deleted successfully'
      };
    }
    return { isSuccess: false, message: 'Failed to delete district' };
  } catch (error: any) {
    console.error("Error deleting district:", error);
    return {
      isSuccess: false,
      message: error.response?.data?.message || 'Failed to delete district'
    };
  }
};
 
const updateAreaPincode = async (data: any) => {
  try {
    const response = await api.put(ApiConstant.updateAreaPincode, data);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error updating area and pincode:", error);
    return {
      isSuccess: false,
      message: ErrorMessage || "Failed to update area and pincode"
    };
  }
};
const searchSubDistricts = async (filter: { keyword: string }) => {
  try {
    const response = await api.post(ApiConstant.searchSubDistricts, filter);
    return response.data;
  } catch (error) {
    console.error("Error searching subdistricts:", error);
    return [];
  }
};
 
const deleteAreaPincode = async (AreaId: number): Promise<{ isSuccess: boolean; message: string }> => {
  try {
    const response = await api.delete(ApiConstant.deleteAreaPincode, {
      data: { AreaId } // Match C# DTO property casing
    });
 
    return {
      isSuccess: response.data.isSuccess,
      message: response.data.message || "Area/pincode deleted successfully"
    };
  } catch (error: any) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.Message ||
      (error.request ? "Network error" : "Unexpected error");
     
    return { isSuccess: false, message: errorMessage };
  }
};
 

const getSubDistricts = async (pageNumber: any, pageSize: any) => {
  try {
    const result = await api.post(ApiConstant.getSubDistricts, {
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
 
    if (result && result.data) {
      return result.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("Error in getting all Subdistrict data:", e);
    return [];
  }
};
 
const getAllSubDistrictsByFilter = async(searchTerm:any, pageNumber:number, pageSize:number )=>{
  try{
    const result = await api.post(ApiConstant.getAllSubDistrictsByFilter, {
      searchTerm: searchTerm,
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
    if(result && result.data){
      return result.data;
    } else {
      return null;
    }
  }
  catch(e){
    console.log("Error in getting filterSearchAll:", e);
    return[];
  }
};
const createsubdistrict = async (districtData: any) => {
  try {
    const response = await api.post(ApiConstant.createsubdistrict, districtData);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error adding new state:", error);
    return { isSuccess: false };
  }
};
 
const UpdateSubdistrict = async (UpdateSubdistrict: any) => {  
  try {
    const Countries: any = await api
      .put(ApiConstant.UpdateSubdistrict, UpdateSubdistrict)  // Changed from post to put
      .then((result: any) => {
        if (result)            
          return result.data;
        else
          return null;        
      })
      .catch(function (error: any) {
        console.error('error updating subdistrict data.', error);
      });
 
    const response = Countries != null ? Countries : null;        
    return response;
  }
  catch (e) {
    console.log('error in subdistrict function.', e);
    return [];
  }
}
 
const deleteSubdistrict = async (subDistrictId: number) => {
  try {
      const deletesubdistrict: any = await api
      .delete(ApiConstant.DeleteSubdistrict + subDistrictId)
      .then((res: any)=> {
          if(res)            
              return res.data;
          else
              return null;        
      })
      .catch(function (error: any) {
          console.error('error deleting subdistrict.', error);
      });
      const response = deletesubdistrict != null ? deletesubdistrict : null;        
      return response;
  }
  catch
  {
      console.log('error in delete subdistrict');
      return false;
  }
}
const addNewSubDistrict1 = async (districtData: any) => {
  try {
    const response = await api.post(ApiConstant.addNewSubDistrict1, districtData);
    return response?.data || { isSuccess: false };
  } catch (error) {
    console.error("Error adding new sub district:", error);
    return { isSuccess: false };
  }
 
};
 
const getAllDistricts = async (filter:any) => {
  try {
    // Send the `filter.search` value as the request body
    const response = await api.post(ApiConstant.getDirstics, { Keyword: filter.search });
    if (response && response.data) {
      return response.data;
    } else {
      console.error("No data received from API");
      return { isSuccess: false };
    }
  } catch (error) {
    console.error("Error fetching districts:", error);
    return { isSuccess: false };
  }
};
const UserAddressService = {
  getUserAddress,
  deleteUserAddress,
  addUserAddress,
  addAdminAddress1,
  addAdminAddress2,
  editUserAddress,
  getCountries,
  getStates,
  getCities,
  getInvoiceUsers,
  updateGPSLocation,
  getUserAddressById,
  addAdminAddress,
  getAddress,
  getAddressByAreaId,
  apiuserAddress1,
  updateUserAddressOnEdit,
  canEditAddress,
  addArea,
  getAllPincodeArea,
  searchFilterPincode,
  getAllCountryNames,
  getStatesByCountryID,
  getDistrictsByStateId,
  getSubDistrictsByStateId,
  addNewCountry,
  addNewState,
  addNewDistrict,
  addNewSubDistrict,
  GetAllCountries,
  searchFilterCountries,
  UpdateCountries,
  deleteCountries,
  getAllStates,
  getAllStatesByfilter,
  updateState,
  deletestate,
  getDistricts,
  searchStates,
  keywordSearchFilter,
  updatedistrict,
  deleteDistrict,
  searchSubDistricts,
  updateAreaPincode,
  deleteAreaPincode,

  getSubDistricts,
  getAllSubDistrictsByFilter,
  createsubdistrict,
  UpdateSubdistrict,
  deleteSubdistrict,
  addNewSubDistrict1,
  getAllDistricts,

  updateGPSLocation1 ,
 
 
 
  };
 


export default UserAddressService;
